import { useDeepLinks } from '../hooks/useDeepLinks';

/**
 * Component to handle deep links in the app
 * Must be placed inside Router context
 */
const DeepLinkHandler = () => {
  useDeepLinks();
  return null;
};

export default DeepLinkHandler;
